import { TileRequest } from '../requests-queue/TileRequest';

const STATUS = {
  UNLOADED: 'UNLOADED', // Nothing present
  ENQUEUED: 'ENQUEUED', // Image is being downloaded from server
  UPLOADING: 'UPLOADING', // Image is being uploaded to GPU
  LOADED: 'LOADED' // Image is visible
};

export class TileImage {
  visible = true;
  loadStatus = STATUS.UNLOADED;

  // note -- a lot of the classes here look similar. They're basically boxes. TODO - clean up
  constructor (x, y, w, h, mX, mY, zoom, texture, requestQueue) {
    // tile position; units: "Number of Tiles"
    this.x = x;
    this.y = y;

    // tile position on texture TODO Nathan please confirm
    this.mX = mX;
    this.mY = mY;

    // which pyramid zoom level to request image data from
    this.pyramidZoom = zoom;

    // used to request images from the request queue
    this.request = new TileRequest(x, y, w, h, zoom);
    this.request.onTextureLoaded = (response) => this.onTextureLoaded(response);

    this.texture = texture;
    this.requestQueue = requestQueue;
  }

  draw () {
    this.loadTexture();
  }

  loadTexture () {
    if (this.loadStatus !== STATUS.UNLOADED) { // Don't attempt to load textures twice
      return;
    }

    this.requestQueue.enqueue(this.request);
    this.loadStatus = STATUS.ENQUEUED;
  }

  async onTextureLoaded (response) {
    this.loadStatus = STATUS.UPLOADING; // uploading to GPU
    if (response) {
      await this.texture.load(response, true, this.mX, this.mY);
      this.loadStatus = STATUS.LOADED;
    }
  }

  // Cancels outstanding tile requests. Note - function name is not quite accurate but balances "loadTexture".
  unloadTexture () {
    this.requestQueue.cancel(this.request);
    this.loadStatus = STATUS.UNLOADED;
  }
}
